import type { FC } from 'react';
import React from 'react';
import cn from 'classnames';

import styles from './styles.css';
import type { TSubmit } from './models';

export const Submit: FC<TSubmit> = ({
    Button,
    SecurityWarrantyBlock,
    buttonText = 'Продолжить',
    className,
    isNewDesign,
    securityText,
    type,
}) => {
    return type === 'simpleButton' ? (
        <Button block dataTestId="simpleButton" size="m" type="submit" view="primary">
            {buttonText}
        </Button>
    ) : (
        <SecurityWarrantyBlock
            buttonText={buttonText}
            className={cn({ [styles.block]: isNewDesign }, styles.external, className)}
            content={securityText}
            notMarginBottom
        />
    );
};
